import styled from 'styled-components';

export const Button = styled.button`
  background: #576B7A;
  border-radius: 8px;
  font-size: 16px;
  color: #FFFFFF;
  letter-spacing: 0;
  text-align: center;
  margin-top: 10px;
  border: none;
  padding: 15px;
  cursor: pointer;
  opacity: 0;
  height: 0;
  width: 0;
  display: flex;
  transition: all 0.3s ease-in;
  justify-content: space-around;
  align-self: center;
  align-content: center;
  margin-bottom: 25px;
  margin-left: 25px;

  :focus {
    outline:0;
  }

  ${({ active }) => active && `
  opacity: 1;
  height: 50px;
  width: 175px;
`}
`;

export const HintWarningContainer = styled.div`
  background-color: #FCDA50;
  border: 4px solid #F28313;
  border-radius: 8px;
  padding: 15px;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  text-align: center;
`;

export const WarningText = styled.p`
  color: #1F282F;
  font-size: 18px;
  font-family: 'Raleway', sans-serif;
`;

export const WarningSubText = styled.p`
  color: #1F282F;
  font-size: 18px;
  font-family: 'Raleway', sans-serif;
`;

export const WarningButton = styled.button`
  background-color: #F28313;
  width: 25%;
  border: none;
  border-radius: 4px;
  color: white;
  font-size: 14px;
  padding: 10px;

  :hover {
    cursor: pointer;
  }
`;

export const WarningButtonContainer = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: space-evenly;
  padding: 10px;
`;

export const Container = styled.div`
  display: flex;
  align-items: center;
  margin-bottom: 1.5em;

`;

export const Title = styled.h1`
  font-family: 'Staatliches';
  color: #EB8A26;
  line-height: 60px;
  font-size: 60px;
  max-width: 500px;
  text-align: left;
  margin-left: 10px;
  @media(max-width:  900px) {
    text-align: center;
  }
`;